<template>
  <v-card class="elevation-2 overflow-hidden" style="border-radius: 1rem">
    <v-card-actions
        class="pb-0"
        style="width: 100%; z-index: 1;"
        :style="{position: $vuetify.breakpoint.smAndUp ? 'absolute' : 'normal'}"
    >
      <v-spacer></v-spacer>
      <v-btn v-if="!manage" icon color="white" @click="markFavorite" :loading="isLoading('favorite')">
        <v-icon
            :color="instaplay.favorite ? 'amber' : 'black'"
        >
          {{instaplay.favorite ? 'star' : 'star_border'}}
        </v-icon>
      </v-btn>
      <slot v-if="active && !started" name="icon"></slot>
    </v-card-actions>
    <v-layout wrap>
      <v-flex xs12 sm3 class="text-xs-center">
        <v-responsive :aspect-ratio="!$vuetify.breakpoint.xsOnly ? 1 : undefined" class="px-3 pt-3">
          <img :src="instaplay.image"
               v-if="instaplay.image"
               style="max-width: 100%; border-radius: 0.5rem">
          <div v-else :style="imgGrid">
            <template v-for="i in instaplay.numContestants">
              <img
                  :key="i"
                  v-if="instaplay['contestant' + i].image"
                  :src="instaplay['contestant' + i].image"
                  width="100%"
                  style="border-radius: 0.5rem"
                  :class="{'col-start-2': i === 7 && instaplay.numContestants === 7}"
              >
              <div v-else :key="i"
                   :class="{'col-start-2': i === 7 && instaplay.numContestants === 7}"
                   class="headline text-capitalize fill-height overflow-hidden pa-1 primary white--text d-flex align-center justify-center"
                   style="width: 100%; border-radius: 50px; min-height: 60px">
                {{instaplay['contestant' + i].name}}
              </div>

            </template>
          </div>
        </v-responsive>
      </v-flex>
      <v-flex xs12 sm9 class="px-3 pb-2">
        <v-layout column fill-height>
          <v-layout wrap>
            <v-flex xs12>
              <div class="my-3">
                <span class="font-weight-bold headline">{{instaplay.name}}</span>
              </div>
            </v-flex>

            <v-flex xs6>
              <p class="text-capitalize align-baseline">
                {{instaplay.InstaplayType}}
                <v-icon class="px-1 black--text">{{typeIcon}}</v-icon>
              </p>

              <p v-if="!manage">
                <span class="font-weight-bold">By: </span>
                {{instaplay.gameMaster.name}}
                <v-avatar size="32" :key="count">
                  <img :src="thumbs[instaplay.gameMaster.userid]" v-if="thumbs[instaplay.gameMaster.userid]">
                </v-avatar>
              </p>

              <p v-if="manage || instaplay.numplayers > 0">
                <span class="font-weight-bold">Number of Players: </span>
                {{ instaplay.numplayers }}
              </p>

              <p v-if="!completed && !isWinnerDeclared">
            <span v-if="timeToShow === 'start'">
              <span class="font-weight-bold">Time Till Game Start: </span>
            </span>
                <span v-else-if="timeToShow === 'winner'">
              <span class="font-weight-bold">Time To Declare Winner: </span>
              </span>
                <countdown-timer
                    ref="startCountDown"
                    :visible="timeToShow === 'start'"
                    :date="startDate"
                    @finished="timerFinished()"
                    class="d-inline-block">
                </countdown-timer>
                <countdown-timer
                    ref="winnerCountDown"
                    :visible="timeToShow === 'winner'"
                    :date="winnerDate"
                    @finished="timerFinished()"
                    class="d-inline-block">
                </countdown-timer>
              </p>
              <p v-else>
                <span class="font-weight-bold">Winner Declared: </span>
                {{ winnerDeclaredDate }}
              </p>

              <div v-if="started">
                <p>
                  <span class="font-weight-bold">Game started at: </span>
                  {{ new Date(
                  this.instaplay.startYear,
                  this.instaplay.startMonth - 1,
                  this.instaplay.startDay,
                  this.instaplay.startHour,
                  this.instaplay.startMinute).toDateString() }}
                </p>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-2">
              <v-layout column fill-height>
                <p v-if="manage">
                  <span class="font-weight-bold">SCoins at play: </span>
                  {{SCoinsAtPlay}}
                  <img :src="require('../assets/CoinIcon.png')" height="30">
                </p>
                <div v-else>
                  <p v-if="instaplay.InstaplayType !== 'simple' || completed">
                  <span v-if="completed" :class="resultColor" class="font-weight-bold">
                    <span v-if="playResult" class="text-capitalize">
                    {{playResult}}
                    <img v-if="playInfo.playResult === 'win'"
                         :src="require('../assets/CoinPile.png')" height="40">
                    <img v-if="playInfo.playResult === 'lose'"
                         :src="require('../assets/CoinIcon.png')" height="20">
                    </span>
                  </span>
                    <span v-else>
                  <span class="font-weight-bold">Risk: </span>
                  {{risk}}
                  coins
                  <img :src="require('../assets/CoinIcon.png')" height="20">
                  </span>
                  </p>
                  <p>
                    <span class="font-weight-bold">Reward: </span>
                    {{ reward }} coins
                    <img :src="require('../assets/CoinPile.png')" height="40">
                  </p>
                  <p v-if="this.instaplay.InstaplayType === 'pool'">
                  <span class="font-weight-bold">
                    Min - Max SCoins to Play:
                  </span>
                    {{this.instaplay.pool.minCoinsToPlay}} - {{this.instaplay.pool.maxCoinsToPlay}}
                  </p>
                </div>
                <!--          <p><span class="font-weight-bold">Number of players: </span>{{instaplay.numberOfPlayers}}</p>-->

                <v-layout xs12 class="align-self-end mb-2 align-end">
                  <p v-if="instaplay.InstaplayType === 'SCoin line' && !started">
                    <span class="font-weight-bold">Queued: </span>
                    {{instaplay.queued}}
                  </p>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-actions v-if="!manage" style="bottom: 0; width: 100%; align-self: end" class="px-0">
            <v-spacer></v-spacer>
            <v-btn
                round color="accent" depressed
                @click="$emit('play', {completed, active})">
              {{actionText}}
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-divider v-if="manage"></v-divider>
    <v-card-actions v-if="manage">
      <v-menu offset-y>
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <v-btn flat icon small @click="!isOpen && $emit('delete')" :disabled="started || isWinnerDeclared"
                     v-on="{ ...tooltip, ...menu }">
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <v-card v-if="isOpen">
          <v-card-text>
            <v-icon color="warning">warning</v-icon>
            Please close the Instaplay before deleting.
          </v-card-text>
        </v-card>
      </v-menu>
      <v-menu offset-y>
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <v-btn flat icon small @click="!isOpen && $emit('edit')" :disabled="started || isWinnerDeclared"
                     v-on="{ ...tooltip, ...menu }"
                     class="mx-2">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </template>
        <v-card v-if="isOpen">
          <v-card-text>
            <v-icon color="warning">warning</v-icon>
            Please close the Instaplay before editing.
          </v-card-text>
        </v-card>
      </v-menu>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :loading="isLoading('lock')" flat icon small @click="editLock" v-on="on">
            <v-icon>{{closeBtn[0]}}</v-icon>
          </v-btn>
        </template>
        <span>{{closeBtn[1]}}</span>
      </v-tooltip>
      <v-menu
          ref="shareMenu"
          offset-y
          :close-on-content-click="false">
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <v-btn flat icon small
                     v-on="{ ...tooltip, ...menu }"
                     class="mx-2">
                <v-icon>link</v-icon>
              </v-btn>
            </template>
            <span>Get Shareable Link</span>
          </v-tooltip>
        </template>
        <v-card style="min-width: 320px">
          <v-card-text class="pb-0">
            <v-layout column>
              <v-flex>
                <v-text-field
                    v-model="linkDialog.userid"
                    label="User ID (Optional)"
                >
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                    v-model="linkDialog.filter"
                    :items="filterItems"
                    label="Filter-By (Optional)"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-text-field
                    v-model="shareLink"
                    readonly
                    dir="rtl"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer/>
            <Copy :text="shareLink"/>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-spacer></v-spacer>
      <span v-if="manage">
        <v-btn
            @click="$emit('showWinner')"
            v-if="isWinnerDeclared"
            depressed round
        >Show Winner</v-btn>
      <v-btn v-else
             @click="$emit('wsdeclare', !started || !winnerStarted)"
             :class="{'blinking': !started}"
             depressed round color="accent">
        <span class="black--text">Declare Winner</span>
      </v-btn>
      </span>
    </v-card-actions>
  </v-card>
</template>

<script>
    import CountdownTimer from "@/components/CountdownTimer";
    import {mapGetters, mapState} from "vuex";
    import Copy from "@/components/Copy";
    import {win} from "@/services/instaplay";

    export default {
        name: "InstaplayCard",
        components: {Copy, CountdownTimer},
        data() {
            return {
                status: {
                    lock: '',
                    favorite: ''
                },
                started: true,
                winnerStarted: true,
                lock: false,
                linkDialog: {
                    userid: '',
                    filter: '',
                    dialog: false,
                }
            }
        },
        props: {
            instaplay: Object,
            playInfo: Object,
            manage: Boolean,
            active: {
                default: false,
                type: Boolean
            },
            completed: {
                default: false,
                type: Boolean
            },
            mode: String
        },
        computed: {
            ...mapGetters('instaplays', ['isSuccess']),
            ...mapState('thumbnails', ['thumbs', 'count']),
            ...mapState('instaplays', ['poolBalance', 'userPlays']),
            shareLink() {
                let link = `https://scorebook.live/home?InstaplayId=${this.instaplay.InstaplayId}`
                if (this.linkDialog.userid) {
                    link = `${link}&userid=${this.linkDialog.userid}`
                }
                if (this.linkDialog.filter) {
                    link = `${link}&filter=${this.linkDialog.filter}`
                }
                return link
            },
            isLoading() {
                return (mode) => this.status[mode] === 'loading'
            },
            timeToShow() {
                return !this.started ? 'start' : !this.winnerStarted ? 'winner' : ''
            },
            playResult() {
                if (!this.playInfo) return ''
                let prefix = '', amount = '', prize = ''
                if (this.playInfo.playResult === 'win') {
                    prefix = 'won'
                    prize = 'SCoins'
                    if (this.instaplay.InstaplayType === 'simple')
                        if (this.instaplay.simple.prize !== 'scoins')
                            prize = this.instaplay.simple.prize
                    amount = this.playInfo.winSCoins
                } else if (this.playInfo.playResult === 'lose') {
                    if (this.instaplay.InstaplayType === 'simple') return ''
                    prefix = 'lost'
                    amount = this.playInfo.riskedSCoins
                    prize = 'SCoins'
                } else {
                    prefix = this.playInfo.playResult
                }

                return prefix + ' ' + amount + ' ' + prize
            },
            risk() {
                let type = this.instaplay.InstaplayType
                let id = this.instaplay.InstaplayId
                if (this.active && this.reward) {
                    if (this.userPlays[id])
                        return this.userPlays[id].risked
                }
                if (type === 'pool' || type === 'bracket') {
                    return this.instaplay[type].minCoinsToPlay
                }
                return this.instaplay[type].wagerSCoins
            },
            reward() {
                if (this.active) {
                    let play = this.userPlays[this.instaplay.InstaplayId]
                    let type = this.instaplay.InstaplayType
                    let favored = (this.instaplay.contestant1 && this.instaplay.contestant2)
                    && (this.instaplay.contestant1.probability > this.instaplay.contestant2.probability)
                        ? this.instaplay.contestant1 : this.instaplay.contestant2
                    let perCoin
                    if (type === "line")
                        perCoin = !play.selected ? '?' : play.selected === favored.name ? this.instaplay.line.SCoinFavored : 10
                    else if (type === "simple" || type === "pool")
                        perCoin = 0
                    else
                        perCoin = this.instaplay[this.instaplay.InstaplayType].wagerSCoins

                    let riskCoins = type === "pool" || type === "bracket" ? play.risked : play.risked / perCoin
                    let risk = type === "pool" || type === "bracket" ? riskCoins :
                        !play.selected ? '?' : perCoin * riskCoins
                    return win({
                        isLine: type === "line",
                        isSimple: type === "simple",
                        isPool: type === "pool",
                        isBracket: type === "bracket",
                        selectedTeam: play.selected,
                        favoredName: favored.name,
                        perCoin: perCoin,
                        riskCoins: riskCoins,
                        instaplay: this.instaplay,
                        active: this.active,
                        completed: this.completed,
                        selection: play,
                        risk: risk,
                        preview: false
                    })
                }
                return this.instaplay[this.instaplay.InstaplayType].winSCoins
            },
            resultColor() {
                return this.playInfo.playResult === 'win' ? 'green--text'
                    : this.playInfo.playResult === 'lose' ? 'red--text' : ''
            },
            actionText() {
                return this.active ? this.started? 'show' : 'change' : this.completed ? 'show instaplay' : 'play'
            },
            winnerDeclaredDate() {
                let obj = this.instaplay.declareYear ? this.instaplay : this.playInfo
                return new Date(
                    obj.declareYear,
                    obj.declareMonth - 1,
                    obj.declareDay,
                    obj.declareHour,
                    obj.declareMinute).toDateString()
            },
            noPlayers() {
                return this.instaplay.numplayers === 0
            },
            closeBtn() {
                return this.isOpen ? ['lock_open', 'Close Instaplay'] : ['lock', 'Open Instaplay']
                // return this.instaplay.privacy === 'me' ? ['lock', 'open'] : ['lock_open', 'close']
            },
            isOpen() {
                return this.instaplay.status === 'current'
            },
            typeIcon() {
                if (this.instaplay.privacy === 'public') {
                    return 'group'
                } else if (this.instaplay.privacy === 'me') {
                    return 'person'
                } else {
                    return 'mail'
                }
            },
            isWinnerDeclared() {
                return !!this.instaplay.declareYear
            },
            startDate() {
                return {
                    year: this.instaplay.startYear,
                    month: this.instaplay.startMonth,
                    day: this.instaplay.startDay,
                    hour: this.instaplay.startHour,
                    minute: this.instaplay.startMinute
                }
            },
            winnerDate() {
                return {
                    year: this.instaplay.winnerYear,
                    month: this.instaplay.winnerMonth,
                    day: this.instaplay.winnerDay,
                    hour: this.instaplay.winnerHour,
                    minute: this.instaplay.winnerMinute
                }
            },
            imgGrid() {
                let count = Math.ceil(Math.sqrt(this.instaplay.numContestants))
                return {
                    display: 'grid',
                    gap: '.75rem',
                    gridTemplateColumns: `repeat(${count}, 1fr)`,
                    justifyItems: 'center',
                    alignItems: 'center'
                }
            },
            SCoinsAtPlay() {
                switch (this.instaplay.InstaplayType) {
                    case 'simple':
                        return this.instaplay.GMpaidSCoins
                    case 'pool':
                        return this.poolBalance[this.instaplay.InstaplayId]
                }
                return ''
            },
            filterItems() {
                return [...this.$store.state.instaplayForm.register.form.filterItems, ...this.$store.state.instaplayForm.register.form.categoryItems]
            },
        },
        methods: {
            timerFinished() {
                this.$emit('finished')
                this.updateDates()
            },
            updateDates() {
                this.started = this.updateStarted()
                this.winnerStarted = this.updateWinnerStarted()
                if (this.timeToShow === 'start' && this.$refs.startCountDown)
                    this.$refs.startCountDown.start()
                if (this.timeToShow === 'winner' && this.$refs.winnerCountDown)
                    this.$refs.winnerCountDown.start()
            },
            updateStarted() {
                return new Date(
                    this.instaplay.startYear,
                    this.instaplay.startMonth - 1,
                    this.instaplay.startDay,
                    this.instaplay.startHour,
                    this.instaplay.startMinute) < new Date()
            },
            updateWinnerStarted() {
                return new Date(
                    this.instaplay.winnerYear,
                    this.instaplay.winnerMonth - 1,
                    this.instaplay.winnerDay,
                    this.instaplay.winnerHour,
                    this.instaplay.winnerMinute) < new Date()
            },
            editLock() {
                this.status.lock = 'loading'
                const payload = {
                    val: this.instaplay.status === 'current' ? 'close' : 'open',
                    id: this.instaplay.InstaplayId,
                    mode: this.mode
                }
                this.$store.dispatch('instaplays/openCloseInstaplay', payload)
                    .then(() => {
                        this.status.lock = ''
                    })
            },
            markFavorite() {
                this.status.favorite = 'loading'
                const payload = {
                    val: !this.instaplay.favorite,
                    id: this.instaplay.InstaplayId
                }
                this.$store.dispatch('instaplays/markFavoriteInstaplay', payload)
                    .then(() => {
                        this.status.favorite = ''
                    })
            }
        },
        mounted() {
            this.updateDates()
        },
        destroyed() {
            if (this.$refs.startCountDown)
                this.$refs.startCountDown.stop()
            if (this.$refs.winnerCountDown)
                this.$refs.winnerCountDown.stop()
        }
    }
</script>

<style scoped>
  @keyframes blink {
    0% {
      background-color: #ffffff;
    }
    50% {
      background-color: #ffd300;
    }
    100% {
      background-color: #ffffff;
    }
  }

  .blinking {
    animation: blink 1.5s infinite;
  }

  .col-start-2 {
    grid-column-start: 2;
  }
</style>
